/**
 * @generated SignedSource<<db5cd749cbe3b6fdeebff5d4b413ffa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "feedids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "feeds",
        "variableName": "feedids"
      },
      {
        "kind": "Literal",
        "name": "severityLevel",
        "value": [
          "SEVERE"
        ]
      }
    ],
    "concreteType": "Alert",
    "kind": "LinkedField",
    "name": "alerts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alertDescriptionText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alertHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alertHeaderText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alertSeverityLevel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alertUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "effectiveEndDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "effectiveStartDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBarQuery",
    "selections": (v1/*: any*/),
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageBarQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "553d40966e1bb1f1b92ec372c2443555",
    "id": null,
    "metadata": {},
    "name": "MessageBarQuery",
    "operationKind": "query",
    "text": "query MessageBarQuery(\n  $feedids: [String!]\n) {\n  alerts(severityLevel: [SEVERE], feeds: $feedids) {\n    feed\n    id\n    alertDescriptionText\n    alertHash\n    alertHeaderText\n    alertSeverityLevel\n    alertUrl\n    effectiveEndDate\n    effectiveStartDate\n  }\n}\n"
  }
};
})();

node.hash = "a2759ea693eb241ef3041feb8b0ddda2";

export default node;
